import React, { useState, useEffect } from 'react';
import Grid from '@mui/material/Grid2';
import { FONT_COLOR } from '../const/general'
import CommonCard from '../item/common_card';
import { TypographyTitleLarge } from '../style/typography'
import { BoxCenterStart } from '../style/box'

export default function DamageIncidents(props) {
    const [mainDamageVal, setMainDamageVal] = useState(0);
    const [finishVal, setFinishVal] = useState(0);
    const [ongoingVal, setOngoingVal] = useState(0);

    const formatVal = (v) => {
        if (v === null || v === undefined) return '-';
        if (typeof v === 'string' && v.trim().length === 0) return '-';
        if (Array.isArray(v) && v.length === 0) return '-';
        return v;
    };

    // mainDamageVal の監視（null / 空文字 / 空配列 を '-' に）
    useEffect(() => {
        const v = props.mainDamageVal;
        setMainDamageVal(formatVal(v));
    }, [props.mainDamageVal]);

    // finishVal の監視（同様のルール）
    useEffect(() => {
        setFinishVal(formatVal(props.finishVal));
    }, [props.finishVal]);

    // ongoingVal の監視（同様のルール）
    useEffect(() => {
        setOngoingVal(formatVal(props.ongoingVal));
    }, [props.ongoingVal]);

    // 初回セット（マウント時）
    useEffect(() => {
        setMainDamageVal(formatVal(props.mainDamageVal));
        setFinishVal(formatVal(props.finishVal));
        setOngoingVal(formatVal(props.ongoingVal));
    }, []);

    return (
        <Grid container columns={12} spacing={0} >
            {props.titleDamageIncidents !== undefined &&
                <Grid size={{ xs: 7, md: 7 }}>
                    <CommonCard
                        child={
                            <BoxCenterStart sx={{ flexDirection: "column", alignItems: "center" }}>
                                <TypographyTitleLarge style={{ color: FONT_COLOR, fontSize: props.isPageSummary ? "1.5rem" : '3rem', marginTop: props.isPageSummary ? '10px' : '20px' }}>{mainDamageVal}</TypographyTitleLarge>
                            </BoxCenterStart>
                        }
                        title={props.titleDamageIncidents}
                        xsHeight="100px"
                        height={props.height}
                    />
                </Grid>
            }
            {props.titleResolved !== undefined && props.titleInProgress !== undefined &&
                <Grid size={{ xs: 5, md: 5 }}>
                    <BoxCenterStart sx={{ width: '100%', flexDirection: 'column', gap: 1, alignItems: 'stretch' }}>
                        <CommonCard
                            child={
                                <BoxCenterStart >
                                    <TypographyTitleLarge sx={{ color: FONT_COLOR, 
                                        fontSize: props.isPageSummary &&  "1rem !important ", 
                                        lineHeight : props.isPageSummary &&  "normal !important "
                                        }}>{finishVal}</TypographyTitleLarge>
                                </BoxCenterStart>
                            }
                            title={props.titleResolved}
                            xsHeight="50px"
                            height={props.height}
                        />
                        <CommonCard
                            child={
                                <BoxCenterStart >
                                    <TypographyTitleLarge sx={{ color: FONT_COLOR, 
                                        fontSize: props.isPageSummary && "1rem !important ", 
                                        lineHeight : props.isPageSummary &&  "normal !important "
                                        }}>{ongoingVal}</TypographyTitleLarge>
                                </BoxCenterStart>
                            }
                            title={props.titleInProgress}
                            xsHeight="50px"
                            height={props.height}
                        />
                    </BoxCenterStart>
                </Grid>
            }
        </Grid>
    );
}